"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOffset = exports.isTabletRes = exports.isMobileRes = void 0;
var isMobileRes = function () {
    if (window.innerWidth < 768) {
        return true;
    }
    return false;
};
exports.isMobileRes = isMobileRes;
var isTabletRes = function () {
    if (window.innerWidth <= 991) {
        return true;
    }
    return false;
};
exports.isTabletRes = isTabletRes;
var getOffset = function (element) {
    var rect = element.getBoundingClientRect();
    return {
        left: rect.left + window.scrollX,
        top: rect.top + window.scrollY,
    };
};
exports.getOffset = getOffset;
